
import { defineComponent, onMounted, watch, computed } from "vue";
import { trans } from "@/globals/translator";
import usePage from "@/composables/usePage";
import Grid from "@moonlight/vue3/components/Grid.vue";
import PageTitle from "@/components/common/PageTitle.vue";
import RichText from "@/components/common/RichText.vue";
import Loading from "@/components/common/Loading.vue";
import { useHead } from "@vueuse/head";
import { getSEODescription } from "@/utils/sanityUtils";

export default defineComponent({
  components: {
    Grid,
    PageTitle,
    RichText,
    Loading,
  },
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { page, fetchPage, requestState } = usePage();
    onMounted(() => {
      fetchPage({
        page: props.slug,
      });
    });
    watch(
      () => props.slug,
      () => {
        fetchPage({
          page: props.slug,
        });
      },
      { immediate: true }
    );

    useHead({
      title: computed(
        () =>
          trans("general.window_title_template", {
            current_page: page.value?.title,
          }) as string
      ),
      meta: [
        {
          name: "description",
          content: computed(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            () => getSEODescription(page.value?.body as any[]) as string
          ),
        },
      ],
    });
    return {
      page,
      trans,
      requestState,
    };
  },
});
